// Need to use the React-specific entry point to import createApi
import type {
  GlobalSearchRequest,
  GlobalSearchResponse,
} from 'src/api/ProactApiClient';
import {searchApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const searchApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    globalSearch: builder.query<GlobalSearchResponse, GlobalSearchRequest>({
      queryFn: clientQuery(params => searchApiClient.search(params)),
      // Transient, uncached results — no providesTags, don't keep stale data around.
      keepUnusedDataFor: 0,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useLazyGlobalSearchQuery} = searchApi;
